import { componentMapping } from "../../lib/component.mapping";
import {
  DynamicComponentKey,
  DynamicComponentPropsModel,
} from "./DynamicComponent.model";

const DynamicComponent = <T extends DynamicComponentKey>(
  props: DynamicComponentPropsModel<T>,
) => {
  const Component = componentMapping[props.type];

  // Add error handling for undefined components
  if (!Component) {
    console.log(
      `Component "${String(props.type)}" not found in componentMapping. Available components:`,
      Object.keys(componentMapping),
    );
    return (
      <div>Error: Component &quot;{String(props.type)}&quot; not found</div>
    );
  }

  return <Component {...(props.parameters as any)} />;
};

export default DynamicComponent;
